module.exports = __webpack_public_path__ + "static/media/h12.00474d7d.jpeg";